import { $create, $getState, $setState, createState, DecoratorNode, type LexicalNode } from 'lexical'
import { ReactNode } from 'react'
import { MentionComponent } from './MentionComponent'

export type MentionData = {
  id: string
  label: string
  metadata?: { [key: string]: unknown } | unknown
}

export const mentionState = createState<'mentionState', MentionData>('mentionState', {
  parse: (v: unknown): MentionData => {
    if (typeof v === 'object' && v !== null) {
      const { id, label, metadata } = v as { id?: string; label?: string; metadata?: string }

      if (typeof id === 'string' && typeof label === 'string') {
        return { id, label, metadata }
      }
    }
    return { id: '', label: '' }
  },
})

export class MentionNode extends DecoratorNode<ReactNode> {
  $config() {
    return this.config('mention', {
      extends: DecoratorNode,
      stateConfigs: [{ flat: false, stateConfig: mentionState }],
    })
  }

  createDOM(): HTMLElement {
    return document.createElement('span')
  }

  updateDOM(): false {
    return false
  }

  decorate(): ReactNode {
    const state = $getState(this, mentionState)

    return <MentionComponent nodeKey={this.getKey()} id={state.id} mention={state.label} />
  }

  getTextContent(): string {
    const state = $getState(this, mentionState)
    return `@${state.label}`
  }
}

export function $createMentionNode(id: string, label: string, metadata?: { [key: string]: unknown } | unknown): MentionNode {
  return $setState($create(MentionNode), mentionState, { id, label, metadata })
}

export function $isMentionNode(node: LexicalNode | null | undefined): node is MentionNode {
  return node instanceof MentionNode
}
